import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { ApplicationForm } from './pages/ApplicationForm';
export function AppRouter() {
  return <BrowserRouter data-id="element-15">
      <Routes data-id="element-16">
        <Route path="/" element={<App data-id="element-18" />} data-id="element-17" />
        <Route path="/application" element={<ApplicationForm data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}